import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import HowItWorksSection from './components/HowItWorksSection';
import FaqSection from './components/FaqSection';
import ConsultationSection from './components/ConsultationSection';
import LocalSection from './components/LocalSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: 'Inter, sans-serif' }}>
      <NavBar />
      <main>
        <HeroSection />
        <StatsBar />
        <ProblemSection />
        <SolutionSection />
        <BenefitsSection />
        <TestimonialsSection />
        <HowItWorksSection />
        <FaqSection />
        <ConsultationSection />
        <LocalSection />
      </main>
      <FooterSection />
    </div>
  );
}
